var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Sidebar'),_c('router-view'),_c('Plug'),_c('Popit'),_c('Thanks'),_c('GetPrize'),_c('PopitWin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }